import React, { useState } from 'react';
import api from '../services/api-mysql';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

const AddAchiever = ({ onAchieverAdded }) => {
  const courseOptions = [
    'Project Management Professional (PMP)®',
    'Certified Associate in Project Management (CAPM)®',
    'Program Management Professional (PgMP)®',
    'Portfolio Management Professional (PfMP)®',
    'PMI Agile Certified Practitioner (PMI-ACP)®',
    'PMI Risk Management Professional (PMI-RMP)®',
    'PMI Professional in Business Analysis (PMI-PBA)®'
  ];
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    role: '',
    course: 'Project Management Professional (PMP)®',
    date: new Date().toISOString().split('T')[0]
  });
  const [image, setImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [cropAspect, setCropAspect] = useState(1);

  const formatLocalDate = (dateString) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      setShowCropper(true);
    }
  };

  const handleCrop = () => {
    if (cropper) {
      setCroppedImage(cropper.getCroppedCanvas({ maxWidth: 800, maxHeight: 800, imageSmoothingQuality: 'high' }).toDataURL('image/jpeg', 0.9));
      setShowCropper(false);
    }
  };

  const handleZoom = (ratio) => {
    if (cropper) cropper.zoom(ratio);
  };

  const handleRotate = (degree) => {
    if (cropper) cropper.rotate(degree);
  };

  const handleReset = () => {
    if (cropper) cropper.reset();
  };

  const handleAspectRatio = (ratio) => {
    setCropAspect(ratio);
    if (cropper) cropper.setAspectRatio(ratio);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('AddAchiever - Submitting course:', formData.course);
      
      const data = new FormData();
      data.append('name', formData.name);
      data.append('company', formData.company);
      data.append('role', formData.role);
      data.append('course', formData.course);
      
      console.log('AddAchiever - FormData course:', data.get('course'));
      const [y, m] = formData.date.split('-').map(Number);
      data.append('year', y);
      data.append('month', monthNames[m - 1]);
      data.append('date', formData.date);

      if (croppedImage) {
        // Convert base64 to blob
        const response = await fetch(croppedImage);
        const blob = await response.blob();
        data.append('image', blob, 'cropped-image.jpg');
      }

      await api.post('/achievers', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // Reset form
      setFormData({
        name: '',
        company: '',
        role: '',
        course: 'Project Management Professional (PMP)®',
        date: new Date().toISOString().split('T')[0]
      });
      setImage(null);
      setCroppedImage(null);
      setShowCropper(false);

      // Show success message
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);

      // Notify parent component
      onAchieverAdded();
    } catch (error) {
      console.error('Error adding achiever:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderHomePreview = () => {
    const formattedDate = formatLocalDate(formData.date);

    return (
      <div className="card preview-card shadow-sm border-0" style={{borderRadius: '12px', overflow: 'hidden'}}>
        <div className="card-body text-center py-4">
          <div className="mb-3 position-relative d-inline-block">
            <div
              style={{cursor: 'pointer'}}
              onClick={() => {
                if (image) {
                  setShowCropper(true);
                } else {
                  document.getElementById('preview-image-input').click();
                }
              }}
              title={image ? 'Click to re-crop' : 'Click to add photo'}
            >
              {croppedImage ? (
                <img
                  src={croppedImage}
                  alt="Preview"
                  style={{width: '120px', height: '120px', objectFit: 'cover', borderRadius: '50%', border: '4px solid #e9ecef', boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}
                />
              ) : (
                <div style={{width: '120px', height: '120px', borderRadius: '50%', border: '3px dashed #ced4da', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', flexDirection: 'column'}}>
                  <i className="bi bi-camera-fill text-muted" style={{fontSize: '2rem'}}></i>
                  <small className="text-muted" style={{fontSize: '0.65rem', marginTop: '2px'}}>Add Photo</small>
                </div>
              )}
              <span className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '32px', height: '32px', fontSize: '0.85rem', border: '2px solid white', boxShadow: '0 1px 4px rgba(0,0,0,0.2)'}}>
                <i className="bi bi-pencil-fill"></i>
              </span>
            </div>
            <input
              id="preview-image-input"
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{display: 'none'}}
            />
          </div>
          <h6 className="card-title fw-bold text-dark mb-1" style={{fontSize: '1.3rem'}}>
            {formData.name || 'Your Name'}
          </h6>
          <p className="text-muted mb-1" style={{fontSize: '1.3rem'}}>
            {formData.company || 'Company'}
          </p>
          <p className="text-primary fw-semibold mb-2" style={{fontSize: '1.25rem'}}>
            {formData.role || 'Role'}
          </p>
          <p className="text-dark mb-2" style={{fontSize: '0.95rem'}}>
            {formData.course || 'Course'}
          </p>
          <div>
            <span className="badge bg-success" style={{fontSize: '0.85rem', padding: '6px 12px'}}>
              <i className="bi bi-calendar-check me-1"></i>
              {formattedDate}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="card border-0 shadow-sm bg-white rounded-3">
      <div className="card-header bg-white border-0">
        <h5 className="mb-0">
          <i className="bi bi-person-plus me-2"></i>Add New Achiever
        </h5>
      </div>
      <div className="card-body">
        {showSuccess && (
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            <i className="bi bi-check-circle me-2"></i>
            PMP Achiever Added Successfully!
            <button type="button" className="btn-close" onClick={() => setShowSuccess(false)}></button>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">Company *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">Role *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">Achievement Date *</label>
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-8 mb-3">
                  <label className="form-label fw-semibold">Course *</label>
                  <select
                    className="form-select"
                    name="course"
                    value={formData.course}
                    onChange={handleInputChange}
                    required
                  >
                    {courseOptions.map(course => (
                      <option key={course} value={course}>{course}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="form-label fw-semibold">Profile Image *</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleImageChange}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex flex-column align-items-center">
                <div className="w-100 mb-3">
                  <h6 className="text-center mb-3">Home Page Preview</h6>
                  {renderHomePreview()}
                </div>
                <div className="d-flex align-items-end justify-content-end w-100">
                  <div className="pt-3">
                    <button type="submit" className="btn btn-primary me-2" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Adding...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-plus-circle me-2"></i>Add Achiever
                        </>
                      )}
                    </button>
                    <button type="reset" className="btn btn-secondary">
                      <i className="bi bi-arrow-clockwise me-2"></i>Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        {/* Cropper Modal */}
        {showCropper && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="bi bi-crop me-2"></i>Crop Image
                  </h5>
                  <button type="button" className="btn-close" onClick={() => setShowCropper(false)}></button>
                </div>
                <div className="modal-body p-0">
                  <Cropper
                    src={image}
                    style={{ height: 500, width: '100%' }}
                    aspectRatio={cropAspect}
                    guides={true}
                    viewMode={1}
                    dragMode="move"
                    scalable={true}
                    zoomable={true}
                    rotatable={true}
                    cropBoxMovable={true}
                    cropBoxResizable={true}
                    background={true}
                    responsive={true}
                    checkOrientation={false}
                    onInitialized={(instance) => setCropper(instance)}
                  />
                  <div className="d-flex flex-wrap justify-content-center gap-2 p-3 bg-light border-top">
                    <div className="btn-group btn-group-sm">
                      <button type="button" className={`btn ${cropAspect === 1 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => handleAspectRatio(1)} title="Square">
                        <i className="bi bi-square me-1"></i>1:1
                      </button>
                      <button type="button" className={`btn ${cropAspect === 4/3 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => handleAspectRatio(4/3)} title="Landscape">
                        <i className="bi bi-aspect-ratio me-1"></i>4:3
                      </button>
                      <button type="button" className={`btn ${cropAspect === 3/4 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => handleAspectRatio(3/4)} title="Portrait">
                        <i className="bi bi-phone me-1"></i>3:4
                      </button>
                      <button type="button" className={`btn ${cropAspect === 0 ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => handleAspectRatio(0)} title="Free">
                        <i className="bi bi-arrows-fullscreen me-1"></i>Free
                      </button>
                    </div>
                    <div className="btn-group btn-group-sm">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => handleZoom(0.1)} title="Zoom In">
                        <i className="bi bi-zoom-in"></i>
                      </button>
                      <button type="button" className="btn btn-outline-secondary" onClick={() => handleZoom(-0.1)} title="Zoom Out">
                        <i className="bi bi-zoom-out"></i>
                      </button>
                    </div>
                    <div className="btn-group btn-group-sm">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => handleRotate(-90)} title="Rotate Left">
                        <i className="bi bi-arrow-counterclockwise"></i>
                      </button>
                      <button type="button" className="btn btn-outline-secondary" onClick={() => handleRotate(90)} title="Rotate Right">
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleReset} title="Reset">
                      <i className="bi bi-arrow-repeat me-1"></i>Reset
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => document.getElementById('preview-image-input').click()} title="Choose different image">
                      <i className="bi bi-image me-1"></i>Change Image
                    </button>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowCropper(false)}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleCrop}>
                    <i className="bi bi-check-lg me-2"></i>Apply Crop
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddAchiever;
